/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CommonBannedAsinBulkCopyResponseDTO interface.
 */
export function instanceOfCommonBannedAsinBulkCopyResponseDTO(value) {
    return true;
}
export function CommonBannedAsinBulkCopyResponseDTOFromJSON(json) {
    return CommonBannedAsinBulkCopyResponseDTOFromJSONTyped(json, false);
}
export function CommonBannedAsinBulkCopyResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'addedAsinCount': json['addedAsinCount'] == null ? undefined : json['addedAsinCount'],
        'addedBrandCount': json['addedBrandCount'] == null ? undefined : json['addedBrandCount'],
    };
}
export function CommonBannedAsinBulkCopyResponseDTOToJSON(json) {
    return CommonBannedAsinBulkCopyResponseDTOToJSONTyped(json, false);
}
export function CommonBannedAsinBulkCopyResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'addedAsinCount': value['addedAsinCount'],
        'addedBrandCount': value['addedBrandCount'],
    };
}
